<div class="player-container">
  <div class="spoty-player d-none d-xl-block" #player [@opacityAnimation] *ngIf="show" >
    <div class="row d-flex align-items-center justify-content-between">
      <div class="col-xl-3 col-xxl-3 d-flex align-items-center justify-content-start">
        <div class="d-flex align-items-center">
          <img *ngIf="current?.cover_url" [src]="current?.cover_url" style="width: 56px; height: 56px; border-radius: 12px; object-fit: cover">
          <img *ngIf="!current?.cover_url" style="width: 56px; height: 56px; border-radius: 12px; background-color: #ccc; filter: blur(3px);">
        </div>

        <div class="overflow-hidden ms-3">
          <span class="d-block text-truncate">{{current.title}}</span>
          <span class="d-block text-muted text-truncate">{{current.artists_line}}</span>
        </div>
      </div>
      
      <div class="col-xl-5 col-xxl-6" style="max-height: 80px;">
        <div class="d-flex align-items-center justify-content-center">
          <button type="button" class="button-wrapper d-flex align-items-center justify-content-center"
            style="cursor: pointer; width: 44px; height: 44px;" (click)="prev()"
            [disabled]="(current && playlist) ? (current.number == playlist.tracks[0].number) : true">
            <mat-icon style="font-size: 48px; width: 100%; height: 100%;">skip_previous</mat-icon>
          </button>

          <button class="button-wrapper d-flex align-items-center justify-content-center mx-4"
            style="width: 44px; height: 44px;" (click)="(current && is_play) ? pause() : play()">
            <ng-container>
              <mat-icon [ngClass]="{ 'd-none': !is_play }" style="font-size: 48px; width: 100%; height: 100%;">
                pause_circle
              </mat-icon>

              <mat-icon [ngClass]="{ 'd-none': is_play }" style="font-size: 48px; width: 100%; height: 100%;">
                play_circle
              </mat-icon>
            </ng-container>
          </button>

          <button class="button-wrapper d-flex align-items-center justify-content-center"
            style="cursor: pointer; width: 44px; height: 44px;" (click)="next()"
            [disabled]="(current && playlist) ? (current.number == playlist.tracks[playlist.tracks.length - 1].number) : true">
            <mat-icon style="font-size: 48px; width: 100%; height: 100%;">skip_next</mat-icon>
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-between" style="font-size: 0.85rem;">
          <small class="d-block">{{formatTime(currentTime)}}</small>
          <mat-slider class="track w-100 " [max]="100" [min]="0" [step]="1" [formControl]="track">
          </mat-slider>  
          <small class="d-block">{{formatTime(duration)}}</small>
        </div>
      </div>

      <div class="col-xl-4 col-xxl-3 d-flex align-items-center justify-content-end">
        <div class="equalizer-wrapper me-4">
          <div *ngIf="is_play" class="equalizer">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
        </div>

        <div *ngIf="volume.value > 0">
          <button mat-icon-button (click)="volume.setValue(0)" class="d-block">
            <mat-icon class="me-1">volume_up</mat-icon>
          </button>
        </div>

        <div *ngIf="volume.value === 0">
          <button mat-icon-button (click)="volume.setValue(0.5)" class="d-block">
            <mat-icon class="me-1">volume_off</mat-icon>
          </button>
        </div>

        <mat-slider class="volume" [max]="1" [min]="0" [step]="0.1" [formControl]="volume">
        </mat-slider>

        <button mat-icon-button (click)="close()" class="d-block">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="mobile-player d-xl-none" [@opacityAnimation] *ngIf="show">
    <div class="player-mini d-flex align-items-center px-3">
      <div class="w-100 overflow-hidden">
        <small>
          <span class="d-block text-truncate">{{current.title}}</span>
          <span class="d-block text-muted text-truncate">{{current.artists_line}}</span>
        </small>
      </div>

      <div class="d-flex align-items-center justify-content-between">
        <button class="button-wrapper d-flex align-items-center justify-content-center"
          style="cursor: pointer; width: 39px; height: 39px;" (click)="prev()"
          [disabled]="(current && playlist) ? (current.number == playlist.tracks[0].number) : true">
          <mat-icon>skip_previous</mat-icon>
        </button>

        <button class="button-wrapper d-flex align-items-center justify-content-center"
          style="cursor: pointer; width: 39px; height: 39px;" (click)="(current && is_play) ? pause() : play()">
          <mat-icon *ngIf="current && is_play">pause_circle</mat-icon>
          <mat-icon *ngIf="!current || (current && !is_play)">play_circle</mat-icon>
        </button>

        <button class="button-wrapper d-flex align-items-center justify-content-center"
          style="cursor: pointer; width: 39px; height: 39px;" (click)="next()"
          [disabled]="(current && playlist) ? (current.number == playlist.tracks[playlist.tracks.length - 1].number) : true">
          <mat-icon>skip_next</mat-icon>
        </button>
      </div>

      <div class="d-flex align-items-center">
        <button mat-icon-button (click)="toggleFullscreen()" class="d-block">
          <mat-icon>list</mat-icon>
        </button>
      </div>

      <div class="d-flex align-items-center">
        <button mat-icon-button (click)="close()" class="d-block">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div> 

    <div class="player-fullscreen px-4" *ngIf="is_playlist_fullscreen">
      <div class="d-flex justify-content-end align-items-center" style="height: 40px;">      
        <div class="d-flex align-items-center">
              <button mat-icon-button (click)="toggleFullscreen()" class="d-block">
                <mat-icon>expand_more</mat-icon>
              </button>
      
              <button mat-icon-button (click)="close()">
                <mat-icon>close</mat-icon>
              </button>
        </div>
      </div>

      <div style="margin: 0 auto;">
        <img *ngIf="current?.cover_url" [src]="current?.cover_url" style="width: 200px; height: 200px; border-radius: 12px; object-fit: cover">
        <img *ngIf="!current?.cover_url" style="width: 200px; height: 200px; border-radius: 12px; background-color: #ccc; filter: blur(3px);">
      </div>

      <div class="w-100 overflow-hidden me-3 mt-2" style="min-height: 50px !important;">
        <span class="d-block text-truncate">{{current.title}}</span>
        <span class="d-block text-muted text-truncate">{{current.artists_line}}</span>
      </div>

      <div *ngIf="playlist" class="mt-1" style="height: 120px;">
        <div class="controls-mobile px-2">
          <mat-slider class="track w-100 " [max]="100" [min]="0" [step]="1" [formControl]="track">
          </mat-slider>

          <div class="d-flex justify-content-between align-items-center text-muted" style="font-size: .85rem;">
            <small class="d-block">{{formatTime(currentTime)}}</small>
            <small class="d-block">{{formatTime(duration)}}</small>
          </div>

          <div class="d-flex align-items-center justify-content-center">
            <button type="button" class="button-wrapper d-flex align-items-center justify-content-center"
              style="cursor: pointer; width: 64px; height: 64px;" (click)="prev()"
              [disabled]="(current && playlist) ? (current.number == playlist.tracks[0].number) : true">
              <mat-icon style="font-size: 48px; width: 100%; height: 100%;">skip_previous</mat-icon>
            </button>

            <button class="button-wrapper d-flex align-items-center justify-content-center"
              style="width: 64px; height: 64px;" (click)="(current && is_play) ? pause() : play()">
              <ng-container>
                <mat-icon [ngClass]="{ 'd-none': !is_play }" style="font-size: 48px; width: 100%; height: 100%;">
                  pause_circle
                </mat-icon>

                <mat-icon [ngClass]="{ 'd-none': is_play }" style="font-size: 48px; width: 100%; height: 100%;">
                  play_circle
                </mat-icon>
              </ng-container>
            </button>

            <button class="button-wrapper d-flex align-items-center justify-content-center"
              style="cursor: pointer; width: 64px; height: 64px;" (click)="next()"
              [disabled]="(current && playlist) ? (current.number == playlist.tracks[playlist.tracks.length - 1].number) : true">
              <mat-icon style="font-size: 48px; width: 100%; height: 100%;">skip_next</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="playlist-mobile mt-1">
        <div *ngFor="let item of playlist.tracks" [ngClass]="{'active': current && item.number == current.number}"
          class="mb-2" (click)="player_service.current.next(item.number)">
          <div style="height:49px;" class="d-flex align-items-center justify-content-between px-1 py-1">
            <div class="d-flex align-items-center w-100">
              <div style="min-width: 30px;">
                <ng-container *ngIf="current?.number === item.number && is_play; else showNumber">
                  <div class="equalizer-wrapper">
                    <div *ngIf="is_play" class="equalizer">
                      <div class="bar"></div>
                      <div class="bar"></div>
                      <div class="bar"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #showNumber>
                  <span class="text-muted">{{item.number}}.</span>
                </ng-template>
              </div>

              <div class="row d-flex align-items-center justify-content-between overflow-hidden m-0 w-100">
                <div class="col-9 overflow-hidden">
                  <span class="d-block text-truncate">{{item.title}}</span>
                  <small class="d-block text-muted text-truncate">{{item.artists_line}}</small>
                </div>
  
                <div class="col-3 d-flex justify-content-end">
                  <small class="text-muted">{{item.duration}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
